import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

:root{
   --background: ${({ theme }) => theme.background};
   --black: ${({ theme }) => theme.text};
   --purple: ${({ theme }) => theme.purple};
   --pink: ${({ theme }) => theme.pink};
   --white: ${({ theme }) => theme.white};
   --nav: ${({ theme }) => theme.nav};
   --nav2: ${({ theme }) => theme.nav2};
}


*,*::before,*::after{
    margin:0;
    padding:0;
    box-sizing:border-box;
    font-family: 'Poppins', sans-serif;
}
html{
  ${"" /* overflow-y: scroll; */}
  scroll-behavior:smooth;
  
}
    body,
    html,
    a {
        font-family: 'Poppins', sans-serif;
    }
    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: var(--background);
        color: ${({ theme }) => theme.text};
        overflow-x: hidden;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin:0;
        padding:0;
    }
    a {
        text-decoration: none;
    }
    a:focus-visible,
    button:focus-visible,
    input:focus-visible,
    textarea:focus-visible {
        outline: 2px solid var(--purple);
        outline-offset: 2px;
    }

    button {
        border: none;
        outline: none;
    }

    img,svg{
        width:100%;
        height:auto;
    }


`;

//  /* Colors */
